<template>
  <div
    class="d-flex vw-100 vh-100 justify-content-center align-items-center"
  >
    <div
      class="container"
    >
      <div class="row d-flex justify-content-center align-items-center g-3">
        <div
            class="col-12 col-md-6 col-lg-4"
        >
          <div
              v-if="info.logo"
              class="text-center"
          >
            <img
                v-if="info.logo_image"
                :src="info.logo_image.path"
                :class="info.logo_image.class ?? 'mb-3'"
                :style="info.logo_image.style ?? 'width: 5rem'"
            />
            <span
              v-else-if="info.logo"
              v-html="info.logo"
            />
            <!--
                        <display-debug>
                          <template #debugView>
                            info: {{ info }}
                          </template>
                        </display-debug>
            -->

          </div>
          <h1 class="display-6 fw-bold lh-1 mb-2 text-center text-secondary">
            {{ info.title }}
          </h1>
          <p class="mx-3 mt-4">
            {{ info.text }}
          </p>
        </div>
        <div
            class="col-12 col-md-6 col-lg-4 pt-4"
        >
          <LoginForm
              :is_password_reset="is_password_reset"
              :return-path="returnPath"
              :google-login="info.googleLogin"
          />
        </div>
      </div>
    </div>
  </div>


  <div
      v-if="1==0"
      class="cms5-login-wrap d-flex flex-wrap justify-content-center align-items-center p-2 w-100 h-100 g-3" style="width: 100%; ">
    <div
      class="d-md-flex flex-grow-1 px-4 px-md-0"
    >
      <div
       class="cms5-login-column  flex-md-fill"
      >

        <div
            v-if="info.logo"
            class="text-center"
        >
          <span v-html="info.logo"></span>
        </div>

        <h1 class="display-6 fw-bold lh-1 mb-2 text-center text-secondary">
          {{ info.title }}
        </h1>
        <p class="col-lg-10 ">
          {{ info.text }}
        </p>
        <!--
        <p class="col-lg-10 d-none">

          Zapomenute heslo si vyresetuje <span @click.prevent="activateReset()">zde</span>
        </p>
        -->
      </div>
      <div
          class="cms5-login-column  flex-md-fill"
      >
        <LoginForm
            :is_password_reset="is_password_reset"
            :return-path="returnPath"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from "@/modules/LoginForm";

import axios from "axios";
export default {
  name: 'ContentView',
  components: {
    LoginForm
  },
  data() {
    return {
      returnPath: null,
      is_password_reset: false,
      info: {
        logo: null,
        title: null,
        text: null,
      }
    }
  },
  methods: {
    activateReset(){
      console.log("activateReset");
      this.is_password_reset = true;
    },
    async getWebInfo(){

      //console.log("dev getWebInfo", this.getApiConfig('general.info.path'));



      axios.defaults.baseURL = this.getBaseRoot();
      await axios({
        //url: this.cfg.api.user.logout_path,
        //method: "post",
        url: this.getApiConfig('general.info.path'),
        method: this.getApiConfig('general.info.method'),

        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log("dev getWebInfo", res.data.response.data);
        this.info = res.data.response.data;
      });
    },

  },
  watch: {
    reloadSignal: {
      handler() {
        //console.log('dev view reloadSignal')

      },
      immediate: true
    },
    '$route' (to, from) {

    }
  },
  created() {

  },
  mounted() {
    if (typeof this.$route.query.path != "undefined") {
      this.returnPath = this.$route.query.path
    }
    this.getWebInfo();
  },
}
</script>
